export class OptionValue {
  constructor(
    public internalValue: string | number,
    public externalValue: string
  ) { }
}
